// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"4ae90d41","411":"e554abc9"}[chunkId] + ".chunk.js";
};